<template>
<div>
  <div class="bg-image">
    <img :src="imageSrc" :alt="alt" :style="{height: height}" class="blured-image"/>
  </div>
  <div class="bg-text" v-if="showContactSales">
    <contact-sales/>
  </div>
</div>
</template>

<script>

import ContactSales from './ContactSales';

export default {
  name: 'BlurredImagePlaceholder',
  components: {
    ContactSales,
  },
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: null,
    },
    showContactSales: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.bg-image {
  filter: blur(8px);
  -webkit-filter: blur(8px);
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* Position text in the middle of the page/image */
.bg-text {
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0, 0.4); /* Black w/opacity/see-through */
  color: white;
  font-weight: bold;
  border: 1px solid #f1f1f1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 80%;
  padding: 20px;
  text-align: center;
}
.blured-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// BlurredImagePlaceHolder.vue?d63917e0